<template>
	<div>
		<a-modal :title="$t('viewCommission.commissionRatio')" :width="550" :visible="visible" @cancel="handleCancel()"
		            :closable="false" :footer="null">
		            <div class="flex around cl-black ftr-1">
		                <div class="ftw600">
		                    {{ $t('viewCommission.level') }}
		                </div>
		                <div class="ftw600">
		                    {{ $t('viewCommission.hours') }}
		                </div>
		                <div class="ftw600">
		                    {{ $t('viewCommission.mtExtraction') }}
		                </div>
		            </div>
		            <div class="flex around cl-black ftr-1 mt-3" v-for="(item,index) in commissionList">
		                <div class="">
		                    {{item.name}}
		                </div>
		                <div class="">
		                    {{item.value_min}} - {{item.value_max}}
		                </div>
		                <div class="">
		                    {{item.extraction_ratio}}%
		                </div>
		            </div>
		            <div class="mt-5 text-center">
		                {{ $t('viewCommission.classCalculationNote') }}
		            </div>
		            <div class="flex justify-content-center mt-4">
		                <button type="button" class="btn btn-theme" @click="handleCancel">{{ $t('viewCommission.gotIt') }}</button>
		            </div>
		        </a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
		},
		data(){
			return{
				commissionList:[],//弹框里展示的分成级别
			}
		},
		created(){
			this.getLevelList()
		},
		methods:{
			handleCancel() {
				this.$emit('cancel')
			},
			// 获取分成比例展示列表
			getLevelList(){
				this.$http.api('teacher/teacher/levelList').then(res => {
					this.commissionList = res.list
				})
			},
		}
	}
</script>

<style>
</style>